if (!customElements.get('faq-split-accordion-list')) {
  customElements.define(
    'faq-split-accordion-list',
    class FaqSplitAccordionList extends HTMLElement {
      constructor() {
        super();
        this.animations = new WeakMap();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      /** Matches the Help page FAQ: a 0.3s ease-out height transition. */
      get duration() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300;
      }

      /**
       * Takes over the native <details> toggle so the answer can slide instead of snapping.
       * Without JavaScript the native toggle still works.
       * @param {MouseEvent} event
       */
      onClick(event) {
        const summary = event.target.closest('summary');
        if (!summary || !this.contains(summary)) return;

        const details = summary.parentElement;
        if (!(details instanceof HTMLDetailsElement)) return;

        event.preventDefault();

        if (details.open && !details.hasAttribute('data-collapsing')) {
          this.collapse(details);
          return;
        }

        if (this.hasAttribute('data-single-open')) {
          for (const other of this.querySelectorAll('details[open]')) {
            if (other !== details) this.collapse(other);
          }
        }

        this.expand(details);
      }

      /** @param {HTMLDetailsElement} details */
      expand(details) {
        const answer = details.querySelector('[data-faq-answer]');
        // A closed <details> can still report its content's full height, so a closed item always starts at 0.
        // An item caught mid-collapse is still open and starts from its current animated height.
        const startHeight = details.open && answer ? answer.offsetHeight : 0;

        details.removeAttribute('data-collapsing');
        details.open = true;
        if (!answer) return;

        this.animate(answer, startHeight, answer.scrollHeight);
      }

      /** @param {HTMLDetailsElement} details */
      collapse(details) {
        const answer = details.querySelector('[data-faq-answer]');
        if (!answer) {
          details.open = false;
          return;
        }

        details.setAttribute('data-collapsing', '');
        this.animate(answer, answer.offsetHeight, 0, () => {
          details.open = false;
          details.removeAttribute('data-collapsing');
        });
      }

      /**
       * @param {HTMLElement} answer
       * @param {number} from - Start height in px
       * @param {number} to - End height in px
       * @param {() => void} [onFinish]
       */
      animate(answer, from, to, onFinish) {
        this.animations.get(answer)?.cancel();

        const animation = answer.animate({ height: [`${from}px`, `${to}px`] }, { duration: this.duration, easing: 'ease-out' });
        this.animations.set(answer, animation);

        animation.onfinish = () => {
          this.animations.delete(answer);
          onFinish?.();
        };
      }
    },
  );
}
